var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTicket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5 3.333a1.667 1.667 0 1 0 3.333 0h8.834a2 2 0 0 1 2 2v9.334a2 2 0 0 1-2 2H8.333a1.667 1.667 0 1 0-3.333 0H2.833a2 2 0 0 1-2-2V5.333a2 2 0 0 1 2-2H5zm1.667 7.5a.833.833 0 0 0-.827.73l-.007.104v.833a.833.833 0 0 0 1.66.105L7.5 12.5v-.833a.833.833 0 0 0-.833-.834zm0-4.166a.833.833 0 0 0-.834.833v.833a.833.833 0 0 0 1.667 0V7.5a.833.833 0 0 0-.833-.833z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.99ec2913.svg";
export { ForwardRef as ReactComponent };